<template>
    <div>
        <div id="contacts"></div>
        <v-container fluid class="screen">
            <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                    <h1>Наши контакты</h1>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 class="text-xs-center mt-3">
                    <div class="contacts-box">Адрес: г. Новокузнецк, Щорса, 5а к4</div>
                    <div class="contacts-box">Работаем круглосуточно без выходных!</div>
                    <div class="contacts-box"
                    >Тел.:
                        <a
                                href="tel:+79512237737"
                                onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
                        >8 (951) 223-77-37
                        </a>
                    </div>
                    <div class="contacts-box"
                    >Тел.:
                        <a
                                href="tel:+73843200462"
                                onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
                        >8 (3843) 200-462</a>
                    </div>
                    <div class="contacts-box">E-mail: <a class="contacts-link" href="mailto:malinasadkoveles@gmail.com">malinasadkoveles@gmail.com</a></div>
                </v-flex>
            </v-layout>
        </v-container>

        <div @click="mapScroll">
            <iframe
                    :style="'pointer-events: '+pointerEvents+';'"
                    src="https://yandex.ru/map-widget/v1/?um=constructor%3A63c45d91d29aa7eb85ccc354f36e73981a5a47713a954e0b495dd073894b0eab&amp;source=constructor"
                    width="100%"
                    height="400px"
                    frameborder="0"
            ></iframe>
        </div>

    </div>
</template>

<script>
export default {
  data () {
    return {
      pointerEvents: 'none'
    }
  },
  methods: {
    mapScroll () {
      if (this.pointerEvents === 'none') {
        this.pointerEvents = 'all'
        return this.pointerEvents
      }
      if (this.pointerEvents === 'all') {
        this.pointerEvents = 'none'
        return this.pointerEvents
      }
    }
  }
}
</script>

<style scoped>
    #contacts {
        position: relative;
        top: -30px;
    }

    a,
    a:hover
    a:visited
    a:active {
        color: green;
        text-decoration: none;
    }

    .contacts-box {
        margin: 10px 0;
    }

    .contacts-link {
        padding-bottom: 1px;
        border-bottom: 1px dotted green;
    }

    .contacts-link:hover {
        border-bottom: none;
    }

    /* MEDIA */
    /* EXTRA SMALL */
    @media (max-width: 600px) {

    }
</style>



// WEBPACK FOOTER //
// src/components/screens/malina/Contacts.vue